// В.2.d-3: Оцифровка души (liv_otsifrovka_dushi, rare Действие).
// «Накладывает на выбранного юнита Посмертный контракт».
//
// Picker: ЛЮБОЙ юнит на поле (свой или вражеский) — по xlsx-тексту цель
// не ограничена стороной. Это значит, что игрок может навесить контракт
// и на врага: тогда при смерти он воскреснет на ВРАЖЕСКОЙ стороне (своей
// для него). Это — продуктовое решение в xlsx, на этапе В.2.d-3 не
// корректируем.
//
// Эффект: applyPosthumousContract(target, cardId).
// Если на поле нет юнитов — Действие сгорает.

import { applyPosthumousContract } from '../../keywords/posthumous_contract.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_otsifrovka_dushi';
const LABEL = 'Оцифровка души';

registerImplementedAbility(CARD_ID, 'oneshot');

// Кандидаты — все живые юниты на поле обоих сторон.
export function actionTargets(state /*, playerIdx */) {
  const out = [];
  for (const p of state.players) {
    for (const u of p.unitsOnField()) {
      if (u.type === 'unit') out.push(u);
    }
  }
  return out;
}

export function resolve(state, playerIdx, target /*, opts */) {
  const all = actionTargets(state, playerIdx);
  if (all.length === 0) {
    state.log?.add(`🔁 ${LABEL}: нет цели — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!target || !target.isAlive || !target.isAlive() || target.type !== 'unit') {
    state.log?.add(`🔁 ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  applyPosthumousContract(state, target, CARD_ID, LABEL);
  const ownerName = state.players?.[target.ownerId]?.name || '?';
  state.log?.add(`🔁 ${LABEL} → ${target.name_ru} [${ownerName}]: Посмертный контракт наложен`);
  return { ok: true };
}
